<template>
  <div id="content" class="internalAssessment previewNewAssessment">
    <div class="container_juge">
      <div class="internalAssessment_inner">

        <!-- <router-link class="goBack" to="/manage_assessments" v-if="showBackBtn">
           <img :src="require('@/assets/backButton.svg')" alt=""/>
         <span>{{$t("Back to the list")}}</span>
       </router-link> -->
      <div class="entete">
        <div class="assessmentNameNex">
          {{internalAssessment.name}}
        </div>
        <div class="header_in_Assess">
          <div class="StatusAndDeadline">
            <div class="judgeInfo">
                <span class="judgeTitle">{{$t("Judge: ")}}</span>
                <span class="judgeName">{{internalAssessment.judges.name}}</span>
            </div>

            <div class="deadline" v-if="internalAssessment.deadline">
              <span class="deadlineTitle">{{$t("Deadline: ")}}</span>

              <span class="deadlineValue">{{ transformDate(getDeadlineDisplay())}}</span>

            </div>
          </div>
          <div class="goRight">
            <div class="status">
                <div class="status inprogress" v-if="internalAssessment.status == 'progress'">
                    <span class="status-text">{{ $t("In progress")}}</span>
                </div>
                <div class="status draft" v-if="internalAssessment.status == 'draft'">
                    <span class="status-text">{{ $t("Draft")}}</span>
                </div>
                <div class="status completed" v-if="internalAssessment.status == 'completed'">
                    <span class="status-text">{{ $t("Completed")}}</span>
                </div>
                <div class="status closed" v-if="internalAssessment.status == 'closed'">
                    <span class="status-text">{{ $t("Closed")}}</span>

                </div>
            </div>
          </div>

        </div>



      </div>
      <div class="description">
          <div class="nopmargin" v-html="internalAssessment.description"></div>

      </div>

      <div class="alertCompleted" v-if="internalAssessment.status == 'completed'">
        The submission date for this assessment is overdue.
      </div>


      <div class="" id="startuoToAssess" >
        <div class="row text-center">
          <span class="titleText">{{ $t('Innovators to assess')}}</span>
        </div>
            <div class="row listOfSelectedStartups" v-if="getNotAssessedStartups().length > 0">
              <div class="col-12 col-lg-6 col-xl-4  candidate" v-for="(candidate, c) in getNotAssessedStartups()" :key="c">
                <div class="candidate_card selectCandidateCard">
                  <div class="candidate_card_head">
                    <span class="name">{{candidate.name}}</span>

                  </div>
                  <div class="candidate_info_content">
                    <span class="titreProperty">Value proposition</span>
                    <span class="valueProperty" v-if="candidate.value_proposition">{{candidate.value_proposition}}</span>
                    <span class="valueProperty" v-else>No data</span>

                  </div>
                  <div class="footer_link_cc" v-if="internalAssessment.judges">

                    <router-link :to="'/judge_vote/'+internalAssessment.judges.accessToken.$oid+'/'+internalAssessment._id.$oid+'/'+candidate._id.$oid"  v-if="candidate._id" >
                      {{ $t("More details")}}

                    </router-link>
                  </div>
                </div>
              </div>

            </div>
            <div class="" v-else>
                {{ $t('You have completed the assessment of all innovators') }}
            </div>
      </div>

      <div class="" id="Completedassessments">
        <div class="row text-center">
          <span class="titleText">{{ $t('Completed assessments')}}</span>
        </div>
        <div class="row listOfSelectedStartups" v-if="votes.length > 0">
          <div class="col-12 col-lg-6 col-xl-4  candidate" v-for="(vote, c) in votes" :key="c">
            <div class="interestLevel">
              <span class="low" v-if="vote.collab_interest_level == 'low'">{{$t("LOW INTEREST")}}</span>
              <span class="medium" v-if="vote.collab_interest_level == 'medium'">{{$t("MEDIUM INTEREST")}}</span>

              <span class="high" v-if="vote.collab_interest_level == 'high'">{{$t("HIGH INTEREST")}}</span>

            </div>
            <div class="candidate_card selectCandidateCard">
              <div class="candidate_card_head">
                  <img :src="require('@/assets/assessDone.svg')"  alt=""/>
                  <span class="name">{{vote.startup.name}}</span>

              </div>

              <div class="avgVote">
                <span class="avgValue"> {{ formattedNumber(vote.totalAverageVote) }}&nbsp;/&nbsp;5</span>
                <div class="detailNote" @click="viewVoteDetail(vote)">
                  <span>Average Score </span>
                  <img :src="require('@/assets/infoCriteria.svg')"  alt=""/>
                </div>
                <VoteDetails v-click-outside="hideDetails" :vote="vote" v-if="showDetailsSelected == vote._id.$oid"/>

              </div>
              <div class="candidate_info_content">
                <span class="titreProperty">Value proposition</span>
                <span class="valueProperty" v-if="vote.startup.value_proposition">{{vote.startup.value_proposition}}</span>
                <span class="valueProperty" v-else>No data</span>

              </div>
              <div class="footer_link_cc" v-if="internalAssessment.judges.accessToken">

                <router-link :to="'/judge_vote/'+internalAssessment.judges.accessToken.$oid+'/'+internalAssessment._id.$oid+'/'+vote.startup._id.$oid"  >
                  {{ $t("More details")}}

                </router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt20" v-else>
          {{$t("No assessment completed yet.")}}
        </div>
      </div>
      </div>
    </div>
  </div>
</template>
<script>
// import { QuillEditor } from '@vueup/vue-quill'
// import '@vueup/vue-quill/dist/vue-quill.snow.css';
// import StartupInfoLine from '@/components/InfoStartupLine.vue'
//
// //import { Toaster, toast } from 'vue-sonner'
 import VoteDetails from '@/components/VoteDetails.vue'
 // import api from '../tools/api';
 //import { toast } from 'vue-sonner'
export default {
  components: {
    VoteDetails
    // QuillEditor,
    // CreateCriteriaModal,
  //  StartupInfoLine
  },
  name: 'JudgeViewSummary',
  data() {
    return {
      dialog:false,
      pageInfo: {
        mainTitle : "My assessment space ",
        subTitle : this.$t("Preview"),
      },
      demoValue:[],
      demoDisable:[],
      showSidePanelBasic: false,
      showDetailsIndexInSelected:null,
      showDetailsSelected:null,

    }
  },
  methods:{
    transformDate(dateString) {
 const date = new Date(dateString);
 const day = String(date.getDate()).padStart(2, '0');
 const month = String(date.getMonth() + 1).padStart(2, '0');
 const year = date.getFullYear();
 return `${day}/${month}/${year}`;
},
    viewVoteDetail(vote){
      console.log(vote);
      this.showDetailsSelected = vote._id.$oid;
      console.log(this.showDetailsSelected);
    },
    formattedNumber(number) {
          return new Intl.NumberFormat('fr-FR', {
            style: 'decimal',
            minimumFractionDigits: 0,
            maximumFractionDigits: 1
          }).format(number);
    },
    hideDetails(){
      this.showDetailsSelected = null; // Hide if already visible
    },
    getDeadlineDisplay(){
      return this.internalAssessment.deadline.date.split(' ')[0];
    },
    getNotAssessedStartups(){
      var votedStartupIds = this.votes.length ? new Set(this.votes.map(vote => vote.startup._id.$oid)) : new Set(); // Handle empty votes array
      console.log(this.votes);
      console.log(votedStartupIds);
      return this.internalAssessment.startups.filter(startup =>
      !votedStartupIds.has(startup._id.$oid)
    );
    }
  },
  mounted(){
    this.dict_loaded = false;
  },
  computed:{

  },
  watch:{

  },
  props: ["internalAssessment","token","votes","showBackBtn"],

}
</script>
<style media="screen" scoped>
.container_juge{
  padding-right:20px;
  padding-left:20px;
}
.internalAssessment{
  padding-top:50px;
  padding-bottom:50px;
}
.internalAssessment_inner{
    padding: 50px;
    padding-top:25px;
    background: #FFF;
}

.status.inprogress {
    display: flex;
    align-items: center;
    background-color: #f7e8c2;
    padding: 5px 15px;
    border-radius: 15px;
}
.status.inprogress svg *{
  fill:#996600;
}
.status.inprogress .status-text {
    color: #996600;
    font-size: 14px;

}
.status.draft {
    display: flex;
    align-items: center;
    background-color: #E3E3E3;
    padding: 5px 15px;
    border-radius: 15px;
}
.status.draft svg *{
  fill:#222;
}

.status.draft .status-text {
    color: #222;
    font-size: 14px;

}

.status.completed {
    display: flex;
    align-items: center;
    background-color: #28a745;
    padding: 5px 15px;
    border-radius: 15px;
}
.status.completed svg *{
  fill:#fff;
}
.status.completed .status-text {
    color: #FFF;
    font-size: 14px;

}


.status.closed {
    display: flex;
    align-items: center;
    background-color: #6c757d;
    padding: 5px 15px;
    border-radius: 15px;
}
.status.closed svg *{
  fill:#fff;
}
.status.closed .status-text {
    color: #fff;
    font-size: 14px;

}

.status{
  gap:5px;
}
.header_in_Assess{
  display:flex;
  width:100%;
  justify-content: space-between;
  margin-top:20px;
  padding:20px;
  border:1px solid #3783C533;
  border-radius:200px;
}



.header_in_Assess .StatusAndDeadline{
  display:flex;
  gap:20px;
    align-items: center;
}

.header_in_Assess .status{
  display:flex;
  gap:5px;
  align-items: center;
}


.deadlineTitle,
.judgeTitle{
text-transform: uppercase;
}


.deadlineTitle{
  color:#04246A;
  text-transform: uppercase;
}
.deadlineValue{
  color:#3783C5;
}

.judgeName{
color:#3982C4;
font-size:16px;
font-weight: 400;
}

.assessmentName{
  font-size:20px;
  color:#000;
  font-weight: 700;
  text-align: center;
}

.judgeInfo{
  text-align:right;
}

.description{
  margin-top:20px;
}


@media screen and (max-width:990px){
  .header{
    flex-direction: column;
    gap:10px;
  }
  .header > div{
    width:100% !important;
    text-align:center;
  }
  .header .StatusAndDeadline{
    justify-content: center;
  }
}


#Completedassessments{
  margin-top:50px;
  padding:50px;
}

#startuoToAssess{
  margin-top:50px;
  padding:50px;
  background:rgba(245, 250, 255, 1);
  border-radius: 15px;
}
#Completedassessments .titleText,
#startuoToAssess .titleText{
  font-size:20px;
  font-weight: 700;
  text-align:center;
  color:rgba(4, 36, 106, 1);
}



  .selectCandidateCard{
    background:#FFF;
  }
  .selectCandidateCard  .candidate_card_head{
      color: #4c81c0;
      padding: 10px 0px;
      background: #FFF;
      text-transform: uppercase;
      font-weight: bold;
    margin-left: 20px;
    margin-right: 20px;
      display:flex;
      align-content: center;
        align-items: center;
    gap:10px;
    min-height: 60px;

  }

.candidate{
  margin-top:20px;
  margin-bottom: 20px;
  position:relative;
}
.candidate_card{
  border: 2px solid #DDDDDD;
border-radius: 15px;
z-index: 5;
height:100%;
display: flex;
flex-direction: column;
}
.candidate_card .candidate_image{
  width:100%;
  height:200px;
  object-fit: cover;
  z-index: 1;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.clickable{
  cursor:pointer;
}
.candidate_card .candidate_links{
  display:flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 20px 5px;

  margin: 0;
}
.candidate_card .candidate_info_content{
  padding:10px 20px ;
  flex-grow: 1;
}
.candidate_card .candidate_info_content .candidate_name{
  font-size:18px;
  line-height:21px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
display:block;
font-weight: 500;
}

.candidate_card .candidate_info_content .candidate_desc{
  font-size:16px;
  line-height:22px;
  margin-top:10px;
  display:block;
  margin-bottom:10px;
}
.candidate_card .candidate_links .details{
  font-size:12px;
  line-height: 15px;
  border-right: 1px solid #DDD;
  display:flex;
  align-items: center;
  text-transform: uppercase;
  color: #3783C5;
  flex: 0.5;

}
.candidate_card .candidate_links .details a{
    text-decoration: none;
}
.candidate_card .candidate_links .details img{
  margin-right:5px;
}
.candidate_card .candidate_links .selectIt{
  font-size:12px;
  line-height: 15px;
  letter-spacing: 0px;
  color: #3783C5;
  text-transform: uppercase;
  flex:0.5;
  align-items: flex-end;

}

.candidate_card .candidate_links .selectIt_fw{
  flex:1;
  align-items: flex-start;
}
.candidate_card .candidate_links .selectIt_fw label{
display:flex;
align-items: center;
gap: 5px;
justify-content: start;
}
.candidate_card .candidate_links .selectIt label{
display:flex;
align-items: center;
gap: 5px;
justify-content: end;
}
.candidate_card .candidate_links .selectIt input{
  width:24px;
  height:24px;
}
.candidate_card .candidate_links .details.noBorder{
  border-right: none;

}

  .candidate_card_head{
    background: #4c81c0;
    padding: 10px;
    color: #FFF;
    text-transform: uppercase;
    font-weight: bold;
    border-radius: 10px 10px 0px 0px;
    display:flex;
    align-content: center;
      align-items: center;
  gap:10px;
  min-height: 60px;
  }

  .selectCandidateCard .titreProperty{
    color:rgba(75, 82, 162, 1);
    font-size:14px;
    font-weight: 400;
    width:100%;
    display:block;
  }
  .selectCandidateCard .valueProperty{
    color:rgba(10, 32, 113, 1);
    font-size:14px;
    font-weight: 700 !important;
    width:100%;
    display:block;
  }

  .footer_link_cc{
 padding-left:20px;
 padding-right:20px;
 margin-bottom:20px;
 margin-top:20px;
  }
  .footer_link_cc a{
      display:block;
      width:100%;
      background:#4c81c0;
      color:#FFF;
      border-radius: 10px;
      padding:10px;
      text-align: center;
  }

  .listOfSelectedStartups{
    margin-top:25px;
  }
  .avgVote{
    padding-left:20px;
    padding-right:20px;
    display:flex;
    gap:10px;
    align-items: center;
    position:relative;
  }
  .avgValue{
    font-weight: 100;
    font-size:32px;
    color:#0A2071;
  }

  .detailNote{
    display:flex;
    gap:10px;
  }
  .detailNote span{
    font-weight: 100;
    color: #0A2071;
  }
  .detailNote img{
    width:16px;
  }

  .mt20{
    margin-top:20px;
  }



  .next-button_small {
      color: #fff;
      background: #3783C5 0% 0% no-repeat padding-box;
      padding: 7px 20px;
      border: none;
      display: flex;
      align-items: center;
          cursor: pointer;
          border-radius: 200px;
  }
  .prev-button {
      color: #3783C5;
      background: # 0% 0% no-repeat padding-box;
      padding: 10px 20px;
      border: none;
      display: flex;
      align-items: center;
          cursor: pointer;
          gap:5px;
          border-radius: 200px;
          border:1px solid #3783C5;
  }
  .next-button {
      color: #fff;
        border:1px solid #3783C5;
      background: #3783C5 0% 0% no-repeat padding-box;
          padding: 10px 20px;
      border: none;
      display: flex;
      align-items: center;
          cursor: pointer;
          border-radius: 200px;
  }

  .status{
    gap:5px;
  }
  .status.inprogress {
      display: flex;
      align-items: center;
      background-color: #FFAA2A;
        padding: 5px 20px !important;
      border-radius: 15px;
  }

  .status.inprogress .status-text {
      color: #fff;
      font-size: 14px;
  }
  .status.draft {
      display: flex;
      align-items: center;
      background-color: #6C68A2;
        padding: 5px 20px !important;
      border-radius: 15px;
  }


  .status.draft .status-text {
      color: #fff;
      font-size: 14px;
  }

  .status.completed {
      display: flex;
      align-items: center;
      background-color: #4ADE80;
        padding: 5px 20px !important;
      border-radius: 15px;
  }

  .status.completed .status-text {
      color: #FFF;
      font-size: 14px;
  }


  .status.closed {
      display: flex;
      align-items: center;
      background-color: #ADB3B5;
        padding: 5px 20px !important;
      border-radius: 15px;
  }

  .status.closed .status-text {
      color: #fff;
      font-size: 14px;
  }

  .entete{
    margin-top:20px;
  }

.assessmentNameNex{
  color:#3783C5;
  font-size:30px;
  font-weight: 500;
  text-align:center;
  width:100%;
}
.goRight{
  display:flex;
  justify-content: flex-end;
}
.description{
  padding:20px;
}
@media screen and (max-width:990px){
.header .StatusAndDeadline{
    flex-direction: column;
    gap:5px;
    align-items: flex-start;
    margin-left: 20px;
}
.header{

  border-radius:20px;
}
.judgeInfo,
.deadline{
  display:flex;
  flex-direction: column;
  gap:0px;
      justify-content: flex-start;
      text-align:left !important;
}
}
@media screen and (max-width:990px){
  .header{
    flex-direction: column;
    border-radius:20px;
  }
  .goRight{
    display:flex;
    justify-content: center;
  }
  .header .StatusAndDeadline{

      margin-left: 0px;
  }
  .judgeInfo,
  .deadline{
    display:flex;
    flex-direction: column;
    gap:0px;
        justify-content: center;
        text-align:center;
  }
}
/*
.assessment-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
    width: 100%;
        background-color: #fbfbfb;
        padding:20px;
}



.next-button {
    color: #fff;
    background: #3783C5 0% 0% no-repeat padding-box;
    padding: 14px 37px;
    border: none;
    display: flex;
    align-items: center;
        cursor: pointer;
        border-radius: 200px;
}


.status.progress {
    display: flex;
    align-items: center;
    background-color: #f7e8c2;
    padding: 5px 15px;
    border-radius: 15px;
}
.status.progress svg *{
  fill:#996600;
}
.status.progress .status-text {
    color: #996600;
    font-size: 14px;
    margin-right: 10px;
}
.status.draft {
    display: flex;
    align-items: center;
    background-color: #E3E3E3;
    padding: 5px 15px;
    border-radius: 15px;
}
.status.draft svg *{
  fill:#222;
}

.status.draft .status-text {
    color: #222;
    font-size: 14px;
    margin-right: 10px;
}

.status.completed {
    display: flex;
    align-items: center;
    background-color: #28a745;
    padding: 5px 15px;
    border-radius: 15px;
}
.status.completed svg *{
  fill:#fff;
}
.status.completed .status-text {
    color: #FFF;
    font-size: 14px;
    margin-right: 10px;
}


.status.closed {
    display: flex;
    align-items: center;
    background-color: #6c757d;
    padding: 5px 15px;
    border-radius: 15px;
}
.status.closed svg *{
  fill:#fff;
}
.status.closed .status-text {
    color: #fff;
    font-size: 14px;
    margin-right: 10px;
}

.next-button .v-img{
  margin-left:10px;
}

.left{

  flex: 1;
  display: flex;
  align-items: center;
  gap: 20px;
}
@media screen and (max-width:990px){
  .assessment-navigation{
    flex-direction: column;
        align-items: left;
    gap:20px;
    padding: 0px;
  }

  .left {
    flex-wrap: wrap;
  }
}
.oneInfoAboutTitle{
  font-size:14px;
  font-weight:700;
  color:#000;
}
.mainColTitle{
  color:rgba(4, 36, 106, 1);
  font-size:20px;
  font-weight: 700;
}
.internalAssessmentContent2Col .criterias,
.internalAssessmentContent2Col .judges{
  padding:20px;
}
.internalAssessmentContent2Col .criterias{

  border:1px solid rgba(55, 131, 197, 1);
  border-radius:20px;
}
.criteriaList{
  display:flex;
  flex-direction: column;
  gap:20px;
  margin-top:20px;
}
.oneCriteria .criteriaHead{
  display:flex;
  gap:10px;
  position:relative;
}
.oneCriteria .criteriaHead .criteriaName{
  font-weight: 700;
  font-size:14px;
  color:rgba(10, 32, 113, 1);
}
.criteriaHead .v-img{
  width:18px;
  flex:none;
}

.vsliderIndicator{
  font-size:15px;
  font-weight: 500;
  color:#000;
}

.selectIt{


display:flex;
align-items: center;
gap: 10px;
}
.selectIt input{
  width:24px;
  height:24px;
}

.criteriaVoting{
  display:flex;
  gap:20px;
  align-items: center;
}
.criteriaVoting .slider{
  width:70%;
}


.zone_input_name{
  text-align: left;
  font-size: 18px;
  line-height: 21px;
  color: rgba(4, 36, 106, 1);
  font-weight: 600;
}
.zone_input_header{
  display:flex;
  gap: 10px;
  position:relative;
}

.innopearl_input{
  border: 1px solid #DDDDDD;
border-radius: 2px;
box-sizing: border-box;
margin-top:10px;
height: 40px;
padding: 5px;
width:100%;
}
@media screen and (max-width: 990px){
.innopearl_input{
  width:100%;
  margin-left:0;
}
}

textarea.innopearl_input{
  border: 1px solid #DDDDDD;
border-radius: 2px;
width: 100%;
margin-top:20px;
margin-bottom: 20px;
padding: 5px;
 resize: none;
 height:60px;

}

.feedBacks{
  margin-top:50px;
  border-top:1px solid #125AA433;
  padding-top:50px;
  margin-bottom: 50px;
}

.internalAssessmentContent2Col{
  margin-top:50px;
}


.selectedStartups{
  margin-top:50px;
  padding:50px;
  background:rgba(245, 250, 255, 1);
  border-radius: 15px;
}
.selectedStartups .titleText{
  font-size:20px;
  font-weight: 700;
  text-align:center;
  color:rgba(4, 36, 106, 1);
}



  .selectCandidateCard{
    background:#FFF;
  }
  .selectCandidateCard  .candidate_card_head{
      color: #4c81c0;
      padding: 10px 0px;
      background: #FFF;
      text-transform: uppercase;
      font-weight: bold;
    margin-left: 20px;
    margin-right: 20px;
      display:flex;
      align-content: center;
        align-items: center;
    gap:10px;
    min-height: 60px;

  }

.candidate{
  margin-top:20px;
  margin-bottom: 20px;
}
.candidate_card{
  border: 2px solid #DDDDDD;
border-radius: 15px;
z-index: 5;
height:100%;
display: flex;
flex-direction: column;
}
.candidate_card .candidate_image{
  width:100%;
  height:200px;
  object-fit: cover;
  z-index: 1;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.clickable{
  cursor:pointer;
}
.candidate_card .candidate_links{
  display:flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 20px 5px;

  margin: 0;
}
.candidate_card .candidate_info_content{
  padding:10px 20px ;
  flex-grow: 1;
}
.candidate_card .candidate_info_content .candidate_name{
  font-size:18px;
  line-height:21px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
display:block;
font-weight: 500;
}

.candidate_card .candidate_info_content .candidate_desc{
  font-size:16px;
  line-height:22px;
  margin-top:10px;
  display:block;
  margin-bottom:10px;
}
.candidate_card .candidate_links .details{
  font-size:12px;
  line-height: 15px;
  border-right: 1px solid #DDD;
  display:flex;
  align-items: center;
  text-transform: uppercase;
  color: #3783C5;
  flex: 0.5;

}
.candidate_card .candidate_links .details a{
    text-decoration: none;
}
.candidate_card .candidate_links .details img{
  margin-right:5px;
}
.candidate_card .candidate_links .selectIt{
  font-size:12px;
  line-height: 15px;
  letter-spacing: 0px;
  color: #3783C5;
  text-transform: uppercase;
  flex:0.5;
  align-items: flex-end;

}

.candidate_card .candidate_links .selectIt_fw{
  flex:1;
  align-items: flex-start;
}
.candidate_card .candidate_links .selectIt_fw label{
display:flex;
align-items: center;
gap: 5px;
justify-content: start;
}
.candidate_card .candidate_links .selectIt label{
display:flex;
align-items: center;
gap: 5px;
justify-content: end;
}
.candidate_card .candidate_links .selectIt input{
  width:24px;
  height:24px;
}
.candidate_card .candidate_links .details.noBorder{
  border-right: none;

}

  .candidate_card_head{
    background: #4c81c0;
    padding: 10px;
    color: #FFF;
    text-transform: uppercase;
    font-weight: bold;
    border-radius: 10px 10px 0px 0px;
    display:flex;
    align-content: center;
      align-items: center;
  gap:10px;
  min-height: 60px;
  }

  .selectCandidateCard .titreProperty{
    color:rgba(75, 82, 162, 1);
    font-size:14px;
    font-weight: 400;
    width:100%;
    display:block;
  }
  .selectCandidateCard .valueProperty{
    color:rgba(10, 32, 113, 1);
    font-size:14px;
    font-weight: 700 !important;
    width:100%;
    display:block;
  }

  .footer_link_cc{
 padding-left:20px;
 padding-right:20px;
 margin-bottom:20px;
 margin-top:20px;
  }
  .footer_link_cc a{
      display:block;
      width:100%;
      background:#4c81c0;
      color:#FFF;
      border-radius: 10px;
      padding:10px;
      text-align: center;
  }

  .listOfSelectedStartups{
    margin-top:25px;
  } */

  .listOfJudges{
    display:flex;
    gap:20px;
    margin-top:10px;
    flex-wrap: wrap;
  }



  .oneJudgeSelected{
    background:#480C831A;
    color:#480C83;
    padding:5px 20px;
    display:flex;
    gap:10px;
    border-radius: 50px;
    border: 1px solid #480C831A;
    position:relative;
  }
  .subTitleJudge{
    font-size:16px;
    font-weight: 700;
    color:#04246A;
    margin-bottom:10px;
    display:block;
    width:100%;
  }

  .judgesWithLicenses
  {
      padding-top:35px;
  padding-bottom:25px;
  border-bottom: 1px solid #BACFE5;
  }
  .judgesWithoutLicences{
    padding-top:35px;
  padding-bottom:25px;
  border-bottom: 1px solid #BACFE5;
  }

  .oneInfoAboutValue p{
    padding:0;
    margin:0;
  }

  .interestLevel{
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%,-50%);
  }
  .interestLevel .low{
    background:#FFE2E5;
    padding:4px 8px;
    font-size:14px;
    font-weight: 700;
    color:#FA5A7D;
    border-radius:20px;
  }
  .interestLevel .medium{
    background:#FFF4DE;
    padding:4px 8px;
    font-size:14px;
    font-weight: 700;
    color:#FFAA2A;
    border-radius:20px;
  }
  .interestLevel .high{
    background:#E7FFEF;
    padding:4px 8px;
    font-size:14px;
    font-weight: 700;
    color:#3AC851;
    border-radius:20px;
  }


  .goBack:hover,
  .goBack{
    display:flex;
    gap:10px;
    align-items: center;
    font-weight: 500;
    color:#000;
    text-decoration: none;
    cursor:pointer;
    margin-bottom: 20px;
  }


  @media screen and (min-width:1301px) and (max-width:1650px){
    .candidate {
      flex: 0 0 auto;
      width: calc(100% / 3);
    }

  }
  @media screen and (min-width:1000px) and (max-width:1300px){
    .candidate {
      flex: 0 0 auto;
      width: 50%;
    }

  }

  .alertCompleted{
    background:#FFE2E5;
    padding:10px 20px;
    font-size:14px;
    font-weight: 700;
    color:#FA5A7D;
    border-radius:20px;
    text-align: center;
  }
</style>

<style media="screen">
  .previewNewAssessment .v-slider-thumb__surface.elevation-2{
    border:1px solid rgba(18, 90, 164, 1) !important;
    color: rgba(18, 90, 164, 0.2) !important;
  caret-color: rgba(18, 90, 164, 0.2) !important;
  backdrop-filter: blur(40px);

  }
.previewNewAssessment .v-slider-thumb__ripple{
  color:#FFF !important;
    caret-color:#FFF !important;
}
.previewNewAssessment .v-slider{
  margin-top:40px;
}
.previewNewAssessment .v-slider.v-input--horizontal .v-slider-thumb__label::before{
  display:none;
}
.previewNewAssessment .v-slider-thumb__label{
  background: #FFF;
  color: #BBB;
  border: 1px solid #BBB;
  border-radius: 10px;
}
.previewNewAssessment  .v-slider.v-input--horizontal .v-slider-thumb__label{
  bottom:10px;
}
.previewNewAssessment .v-slider-track__background{
  background-color: #E1E1E1 !important;
  opacity: 1;
}
.previewNewAssessment  .v-slider .v-input__control{
  margin-left:10px;
  margin-right: 10px;
}
.nopmargin p{
  margin:0px !important;
  margin-bottom:0px !important;
    padding:0px !important;
}
</style>
